import { useCallback } from 'react'
import { useMappedState } from 'redux-react-hook'

export default () => {
  const state = useMappedState(useCallback(state => state, []))
  return { state }
}



// WEBPACK FOOTER //
// ./src/hooks/use-get-state.ts